



















import Campaign from "@/models/campaign";
import { LayoutModule } from "@/store/layout";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SellersCampaignsSummary extends Vue {
  @Prop({ default: "" }) height!: string;
  @Prop({ default: [] }) data!: Campaign[];

  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  details(): void {
    this.$router.push({
      name: "sellersCampaigns",
      params: { summary: "false" },
    });
  }
}
